module.exports = __webpack_public_path__ + "assets/img/1208.4c8fe9df.svg";